var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88889 4H19.1111C19.3469 4 19.573 4.09514 19.7397 4.26448C19.9064 4.43382 20 4.6635 20 4.90299V6.33512C19.9999 6.57459 19.9063 6.80423 19.7396 6.97354L14.0373 12.7653C13.8709 12.9347 13.7776 13.1644 13.7778 13.4037V19.097C13.7778 19.2343 13.747 19.3697 13.6877 19.4931C13.6284 19.6164 13.5423 19.7244 13.4357 19.8089C13.3292 19.8933 13.2052 19.952 13.073 19.9804C12.9408 20.0089 12.804 20.0063 12.6729 19.9729L10.8951 19.5214C10.7029 19.4725 10.5323 19.3598 10.4104 19.2011C10.2884 19.0424 10.2222 18.8468 10.2222 18.6455V13.4037C10.2222 13.1642 10.1285 12.9346 9.96178 12.7653L4.25956 6.97354C4.09317 6.80408 3.99981 6.57446 4 6.33512V4.90299C4 4.6635 4.09365 4.43382 4.26035 4.26448C4.42705 4.09514 4.65314 4 4.88889 4Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fda2644af549e8d0cf4d071f3e24f758.svg";
export { ForwardRef as ReactComponent };